"use client";

import { useContext, useEffect, useState } from "react";
import Splash from "../Splash";
import { LanguageContext } from "@/context/languageContext";
import { HomepageOptions } from "@/types/wordpress";

interface ModuleSplashProps {
  homepageOptions: HomepageOptions;
}

export default function ModuleSplash({ homepageOptions }: ModuleSplashProps) {
  const { language } = useContext(LanguageContext);
  const [data, setData] = useState(
    language === "en"
      ? homepageOptions.moduleSlider
      : homepageOptions.moduleSliderDE
  );

  useEffect(() => {
    setData(
      language === "en"
        ? homepageOptions.moduleSlider
        : homepageOptions.moduleSliderDE
    );
  }, [homepageOptions.moduleSlider, homepageOptions.moduleSliderDE, language]);

  return (
    <div className="homePageSplash">
      {data.slider && data.slider.slider && (
        <Splash slider={data.slider.slider} />
      )}
    </div>
  );
}
